import { render, staticRenderFns } from "./UserStudentFiles.vue?vue&type=template&id=02c693d5&scoped=true&"
import script from "./UserStudentFiles.vue?vue&type=script&lang=ts&"
export * from "./UserStudentFiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c693d5",
  null
  
)

export default component.exports